import isLocationPhysical from '~/booking/utils/isLocationPhysical'
import { BookingLanguage, LevelOfEducation, Location, Subject } from '~/types/booking'
import { Product } from '~/types/product'
import { setBookingForSelfFormErrorActionCreator, setTutorForSelfCartActionCreator } from '~/redux/slices/cart'
import { useAppDispatch } from '~/redux/hooks'

export default function useBookingForSelf(): {
  handleOnLanguageChange: (language: BookingLanguage | null) => void
  handleOnLevelsOfEducationClick: (levelsOfEducation: LevelOfEducation[]) => void
  handleOnLocationChange: (location: Location | null) => void
  handleOnPhysicalLocationTypeClick: (includeTravelExpense: boolean) => void
  handleOnProductClick: (product: Product) => void
  handleOnSubjectClick: (subjects: Subject[]) => void
} {
  const dispatch = useAppDispatch()

  const handleOnLanguageChange = (lang: BookingLanguage | null): void => {
    dispatch(setTutorForSelfCartActionCreator({ language: lang }))
    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'language',
        message: undefined,
      }),
    )
  }

  const handleOnLevelsOfEducationClick = (levelsOfEducation: LevelOfEducation[]): void => {
    dispatch(setTutorForSelfCartActionCreator({ levelsOfEducation }))
    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'levelsOfEducation',
        message: undefined,
      }),
    )
  }

  const handleOnLocationChange = (location: Location | null): void => {
    const options = isLocationPhysical(location) ? undefined : { includeTravelExpense: false }
    dispatch(setTutorForSelfCartActionCreator({ location, ...options }))
    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'location',
        message: undefined,
      }),
    )
  }

  const handleOnPhysicalLocationTypeClick = (includeTravelExpense: boolean): void => {
    dispatch(setTutorForSelfCartActionCreator({ includeTravelExpense }))
  }

  const handleOnProductClick = (product: Product): void => {
    dispatch(setTutorForSelfCartActionCreator({ product }))
    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'product',
        message: undefined,
      }),
    )
  }

  const handleOnSubjectClick = (subjects: Subject[]): void => {
    dispatch(setTutorForSelfCartActionCreator({ subjects }))
    dispatch(
      setBookingForSelfFormErrorActionCreator({
        fieldName: 'subjects',
        message: undefined,
      }),
    )
  }

  return {
    handleOnLanguageChange,
    handleOnLevelsOfEducationClick,
    handleOnLocationChange,
    handleOnPhysicalLocationTypeClick,
    handleOnProductClick,
    handleOnSubjectClick,
  }
}
